import { getPath, PublicationSummary } from "@libry-content/common";
import InternalLink from "../InternalLink";
import { usePublicationLangAttribute } from "../../utils/hooks/usePublicationLangAttribute";

export const PublicationAgentLink = ({ publication }: { publication?: PublicationSummary }) => {
  const publicationLangAttribute = usePublicationLangAttribute(publication);
  const publicationAgentLink = getPublicationAgentLink(publication);
  if (!publication?.author?.name || !publicationAgentLink) return null;
  return (
    <InternalLink href={publicationAgentLink} fontSize="sm" lang={publicationLangAttribute}>
      {publication.author.name}
    </InternalLink>
  );
};

export const getPublicationAgentLink = (publication?: PublicationSummary) => {
  if (!publication?.author?.id || !publication.author.name || !publication.author.type) return undefined;
  return getPath({
    type: publication.author.type,
    name: { nb: publication.author.name, nn: publication.author.name },
    id: publication.author.id,
    identifiers: { norafId: publication.author.norafId },
  });
};
